import { Link } from "react-router-dom";
import { EmptyState } from "../components/ui/EmptyState";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper p-6">
      <div className="w-full max-w-2xl">
        <EmptyState eyebrow="404" title="This CoachGrid page does not exist.">
          <Link className="link" to="/">
            Return to CoachGrid
          </Link>
        </EmptyState>
      </div>
    </div>
  );
}
